export const SCREEN_WIDTH_DESKTOP = 1200
export const SCREEN_WIDTH_TABLET = 960
export const SCREEN_WIDTH_MOBILE = 640
